import React from 'react';
import { Wrapper, PageLead, Breakdown, ContentWrapper } from '@adac-mp/components';

export const NotFound = () => {
	return (
		<Wrapper className="bg-white items-center min-h-[calc(100vh_-_56px)] sm:min-h-[calc(100vh_-_98px)]">
			<ContentWrapper>
				<PageLead
					icon={<Breakdown />}
					headline="Entschuldigung"
					description="Die Seite, die Sie aufgerufen haben, ist leider nicht verfügbar."
				/>
			</ContentWrapper>
		</Wrapper>
	);
};
